import { Component, ojs, v, state, app, component } from "modular-openscriptjs";
import { disposeBootstrapTree, empty } from "../helpers";
import AnnouncementImageView from "./Views/AnnouncementImageView";
import { dom } from "../fotastart";
import Slider from "./Blocks/Slider";
import SliderItem from "./Blocks/SliderItem";
import { api, gc } from "../declarations";

const h = app("h");

ojs(AnnouncementImageView, Slider, SliderItem);

export default class Announcements extends Component {
    announcements = state([]);

    constructor() {
        super();
        this.announcements.listener(this);
    }

    $$user = {
        // Guests don't see announcements; load them the moment someone
        // signs in (this component may already be on screen by then, so
        // $_mounted won't run again).
        authenticated: () => this.getAnnouncements(),
        loggedOut: () => {
            this.announcements.value = [];
        },
    };

    /**
     * @param {State<boolean>} auth - gc.auth, so this re-renders on sign in/out.
     */
    render(auth = gc.auth, ...args) {
        if (!auth?.value) {
            return h.div({ hook: "announcements-holder", class: "d-none" });
        }

        let final = null;

        if (empty(this.announcements.value)) {
            final = h.div({
                class: "d-block d-none w-100 rounded-4 h-100 placeholder",
            });
        }

        const slides = [];

        for (let announcement of this.announcements.value) {
            for (let i in announcement.images) {
                let image = announcement.images[i];
                slides.push(
                    h.SliderItem(
                        {},
                        h.AnnouncementImageView(image, i, announcement),
                    ),
                );
                i++;
            }
        }

        final = h.Slider(
            {
                slides,
                cycle: true,
                interval: 5000,
                hasControls: true,
                hasIndicators: false,
            },
            {
                style: "--slide-radius: var(--bs-border-radius-xl); --cycle-bg-active: transparent;  --cycle-bg: transparent;",
            },
        );

        return h.div({ hook: "announcements-holder" }, final, ...args);
    }

    async getAnnouncements() {
        let res = await api.get(
            "/users/announcements",
            { for: "customer" },
            { silent: true },
        );

        let markup = this.markup();

        let root = null;
        if (markup && markup.length > 0) {
            root = markup[0];
        }

        if (!res) {
            setTimeout(() => {
                root?.classList.add("d-none");
            }, 1500);

            return;
        }

        this.announcements.value = res.data.announcements;

        if (!empty(this.announcements.value)) {
            setTimeout(() => {
                root?.classList.remove("d-none");
            }, 1500);
        } else {
            setTimeout(() => {
                root?.classList.add("d-none");
            }, 1500);
        }
    }

    $_mounted(componentId) {
        let c = component(componentId);
        if (c && gc.auth.value) {
            c.getAnnouncements();
        }
    }

    cleanUp() {
        super.cleanUp();
        let markup = this.markup();

        for (let elem of markup) {
            disposeBootstrapTree(elem);
        }
    }
}

ojs(Announcements);
